module.exports = __webpack_public_path__ + "static/media/bloomberg-tv.ad94cebd.jpg";